import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from '../components/LoginButton';
import './Pages.css';

function Home() {

    const { isAuthenticated, isLoading, user } = useAuth0();

    if (isLoading) return null; // or a spinner

    return (
        <div className="page-container">
            <section className="o11y">
            <h1 className="o11y-title">Welcome to the Self-Service Portal for the Platform Observability Solution</h1>
            <p className="o11y-text">
                This portal allows you to create and manage organizations, manage group access to your organization, 
                and retrieve critical attributes for connecting and sending data to your tenant.
            </p>

            {!isAuthenticated && (
                <div className="o11y-actions">
                <LoginButton />
                </div>
            )}
            </section>

            {/* AUTHENTICATED CONTENT */}
            {isAuthenticated && (
            <>
                <p className="o11y-text" style={{ textAlign: 'center' }}>
                Use the navigation links above or the tiles below to get started.
                </p>
                <div className="features">
                {/* <Link to="/create-organization" className="feature-card-link">
                    <div className="feature-card">
                    <h3 className="o11y-text-white" style={{ textAlign: 'center' }}>Create Organization</h3>
                    <p className="o11y-text-white" style={{ textAlign: 'center' }}>
                        Fill out the form to create a new organization and start accessing O11y.
                    </p>
                    </div>
                </Link> */}
                <Link to="/manage-organizations" className="feature-card-link">
                    <div className="feature-card">
                    <h3 className="o11y-text-white" style={{ textAlign: 'center' }}>Manage Organizations</h3>
                    <p className="o11y-text-white" style={{ textAlign: 'center' }}>
                        Manage organizations owned by you or your team.
                    </p>
                    </div>
                </Link>
                <Link to="/contact" className="feature-card-link">
                    <div className="feature-card">
                    <h3 className="o11y-text-white" style={{ textAlign: 'center' }}>Get some help</h3>
                    <p className="o11y-text-white" style={{ textAlign: 'center' }}>
                        If you have a question or encounter a problem, you can contact the O11y team directly.
                    </p>
                    </div>
                </Link>
                </div>
            </>
            )}
        </div>
    );
}

export default Home;